// Screen `app` (owner: custom-components, F20): a published custom component opened as its own app in the rail.
import { createFileRoute } from '@tanstack/react-router';
import { ComponentAppPage } from '../../../features/custom-components/placements/AppPage';

export const Route = createFileRoute('/_app/apps/$key')({
  component: function ComponentAppRoute() {
    const { key } = Route.useParams();
    return <ComponentAppPage componentKey={key} />;
  },
});
